import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AiChatModule } from './app/ai-chat.module';
import { loadAiChatStyles } from './load-ai-chat-styles';

// AngularJS (ui-bootstrap) на ractive/spa компилирует весь document и подменяет <tab>.
document.querySelectorAll('ai-chat').forEach((el) => {
  el.setAttribute('ng-non-bindable', '');
});

loadAiChatStyles();

platformBrowserDynamic().bootstrapModule(AiChatModule)
  .catch(err => console.error(err));
